import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiStandardResponse } from '@core/models/api/api.models';
import { OtpChannel } from '@core/models/custom-types.model';
import { ApiService } from '@core/services/api/api.service';

const OTP_API_TYPE: Record<OtpChannel, 'email' | 'sms'> = {
  email: 'email',
  cellulare: 'sms'
};

/**
 * OTP di autorizzazione per operazioni sensibili (es. modifica contatto).
 * Allineato a Premi AppService.otpRequest / otpValidate.
 */
@Injectable({
  providedIn: 'root'
})
export class OtpService {
  private readonly apiService = inject(ApiService);

  otpRequest(channel: OtpChannel): Observable<IApiStandardResponse<unknown>> {
    return this.apiService.get<IApiStandardResponse<unknown>>(
      `richiesta-otp/${OTP_API_TYPE[channel]}`
    );
  }

  otpValidate(codice: number): Observable<IApiStandardResponse<unknown>> {
    return this.apiService.get<IApiStandardResponse<unknown>>(
      `valida-otp/${codice}`
    );
  }
}
